import { Flex, Text } from '@chakra-ui/react';
import { tools } from '@halo/ui-chat-react';
import { useAppStore } from '@/store/client';
import { MyOperations } from './MyOperations';
import { AddOperations } from './AddOperations';

export default memo(function My({ isMiniNav }: { isMiniNav: boolean }) {
  const { user } = useAppStore();

  return (
    <Flex
      align="center"
      gap="2"
      justify="space-between"
      w="full"
      flexDirection={isMiniNav ? 'column' : 'row'}
    >
      <MyOperations></MyOperations>
      {!isMiniNav && (
        <Flex flex="1" direction="column" align="flex-start" overflow="hidden">
          <Text
            w="full"
            fontSize="md"
            fontWeight="semibold"
            color="fg"
            truncate
            cursor="pointer"
            onClick={() => tools.copyToClipboard(user?.name)}
          >
            <span>{user?.name}</span>
          </Text>
          <Text
            w="full"
            fontSize="xs"
            fontWeight="medium"
            color="fg.muted"
            truncate
            cursor="pointer"
            onClick={() => tools.copyToClipboard(`@${user?.username}`)}
          >
            <span>@{user?.username}</span>
          </Text>
        </Flex>
      )}
      <AddOperations isMiniNav={isMiniNav} />
    </Flex>
  );
});
